import { LoginResponse, NewLoginRequest, NewLoginResponse } from './types';
import { fetcher } from '../utils';
import { JARVIS_VERSION, LocalStorageKeys } from 'utils/network';
import { v4 as uuidv4 } from 'uuid';
import * as rd from 'react-device-detect';

const iamPath = '/iam-svc/v1/auth';

// Auth uses REACT_APP_API so local dev hits vhagar, staging hits vhagar, prod hits drogon
const AUTH_BASE_URL = `https://${process.env.REACT_APP_API}.schmooze.tech`;

const login = async (tokenId: string) => {
  return fetcher<LoginResponse>('/v1/auth/jarvis/login', {
    method: 'POST',
    body: JSON.stringify({ id_token: tokenId }),
  }, AUTH_BASE_URL);
};

const newLogin = async (payload: NewLoginRequest) => {
  let deviceId = localStorage.getItem(LocalStorageKeys.DeviceId);
  let browser_id = localStorage.getItem(LocalStorageKeys.BrowserId);
  const platform = window.navigator.platform;

  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem(LocalStorageKeys.DeviceId, deviceId);
  }

  if (!browser_id) {
    browser_id = rd.browserName + '-' + rd.browserVersion;
    localStorage.setItem(LocalStorageKeys.BrowserId, browser_id);
  }

  return fetcher<NewLoginResponse>(
    iamPath + '/authorize-jarvis',
    {
      method: 'POST',
      headers: {
        'jarvis-version': '2.0.0',
      },
      body: JSON.stringify({
        id_token: payload.id_token,
        device_key: deviceId,
        app_version: JARVIS_VERSION,
        jarvis_version: JARVIS_VERSION,
        platform: platform,
        jarvis_device_id: deviceId,
        jarvis_browser_id: browser_id,
      }),
    },
    AUTH_BASE_URL,
  );
};

const logout = () => {
  return fetcher('/v1/auth/jarvis/logout', {
    method: 'POST',
    body: JSON.stringify({ device_id: localStorage.getItem(LocalStorageKeys.DeviceId) }),
  }, AUTH_BASE_URL);
};

export { login, newLogin, logout };
